import React from "react";
import { constructAddress } from "../../../AdDetailsPageWeb/SellerInfo";
import { formatDate } from "../../../../../services";
import styles from "./ContacSellertInfo.scss";
import { EntityType } from "../../../../../models/enums";
import FeatureFlags from "../../../../../featureFlags";

const ContacSellertInfo = ({ seller }) => (
  <div className={styles.contactInfo}>
    {seller.legalEntity === EntityType.LegalEntity ? (
      <div>{constructAddress(seller)}</div>
    ) : null}
    <div>
      {`${"Registriran"} ${formatDate(
        seller.registrationDate
      )}`}
    </div>
    <div>
      {seller &&
        seller.legalEntity === EntityType.LegalEntity &&
        FeatureFlags.SHOW_LEGAL_ENTITY
        ? `${"Pravna osoba"}`
        : `${"Fizička osoba"}`}
    </div>
  </div>
);

export default ContacSellertInfo;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/ContactSection/ContacSellertInfo/index.tsx